import { safeParse } from "@/utils/safeParse";
import { merge } from "lodash";
import getParent from "../../utils/getParent";
import reporter from "../report/reporter";
import { getPage, getSearch } from "../shared/global";
import { getAttribute, getFilter } from "./get";
/**
 * 采集点击
 * @param {Element} targetNode
 */
export function material_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33002,
    event_name: "material_click",
    pin_id: targetNode.getAttribute("data-content-id"),
    board_id: targetNode.getAttribute("data-board-id"),
    filter_one: targetNode.getAttribute("data-filter-one"),
    filter_two: targetNode.getAttribute("data-filter-two"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    trackData.pin_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.pin_source = `${page_nm}_${sub_page_nm || ""}`;
  }
  const content_type = getAttribute(targetNode, "data-content-type");
  if (content_type) {
    trackData.content_type = content_type;
  }
  const material_id = targetNode.getAttribute("data-material-id");
  if (material_id) {
    trackData.content_id = material_id;
  }

  if (page_nm === "搜索结果页") {
    const input = document.getElementById("hb_search_input");
    trackData.search_word = input?.value;
    trackData.search_word_type = getSearch().search_word_type;
    trackData.filter_ids = getSearch().filter_ids || [];
  }

  if (page_nm === "专题页") {
    const el = document.querySelector("[data-topic-id]");
    if (el) {
      trackData.click_source_topic_title = el.getAttribute("data-topic-title");
      trackData.click_source_topic_id = el.getAttribute("data-topic-id");
    }
  }

  if (page_nm === "主题页" || page_nm === "发现页") {
    const el = document.querySelector("[data-sort-type]");
    if (el) {
      trackData.sort_type = el.getAttribute("data-sort-type");
    }
  }

  const file_id = getAttribute(targetNode, "data-file-id");
  if (file_id) {
    trackData.file_id = file_id;
  }

  const ext = getAttribute(targetNode, "data-ext");
  if (ext) {
    Object.assign(trackData, safeParse(ext));
  }

  merge(trackData, getFilter(page.page_nm));

  reporter(trackData);
}
